var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAccountReturnRefund = function SvgIconAccountReturnRefund(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.097 2.324a7.5 7.5 0 0 1 11.045 9.981L11.75 8H14A6 6 0 0 0 3.845 3.671zm9.806 11.352A7.5 7.5 0 0 1 1.858 3.695L4.25 8H2a6 6 0 0 0 10.155 4.329z"
  })));
};
export default SvgIconAccountReturnRefund;